module.exports = __webpack_public_path__ + "img/section3_4.eec6e0ab.png";